import { Text } from "../../../../components/common/typography";
import { Heading } from "../../../../components/common/typography";
import { IconShoppingCart } from "@tabler/icons-react";
export function PurchaseOrderNotFound() {
    return (<div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <IconShoppingCart size={64} style={{
            color: "#9CA3AF"
        }}/>
      <Heading variant="h2">Purchase Order Not Found</Heading>
      <Text variant="body" tone="body">
        The purchase order you're looking for doesn't exist or has been removed.
      </Text>
    </div>);
}
